export const formUploadDocumentRoute = (applicationId: number) =>
  `/applicants/applications/${applicationId}/docs/upload/`;
export const formDeleteDocumentRoute = (applicationId: number) =>
  `/applicants/applications/${applicationId}/docs/delete/`;
export const formGetDocumentRoute = (applicationId: number) =>
  `/applicants/applications/${applicationId}/docs/`;
